<template>
    <div :style="'height:' + (height + 139) + 'px'" class="white dialog-border" style="overflow: hidden">
        <v-btn
            color="primary"
            fab
            small
            dark
            bottom
            right
            absolute
            style="margin-bottom: 75px; margin-right: 75px"
            @click = "onMail"
        >
            <v-icon>{{ showMailSlide ? 'mdi-close' : 'mdi-email-outline' }}  </v-icon>
        </v-btn>

        <v-expand-x-transition>
            <v-card elevation="10" v-show="showMailSlide" class="dialog-border " style="position: absolute; width: 930px; height: calc(100% - 45px); right: 73px; top: 5px; z-index: 1">
                <div class="w-100 h-100 white">
                    <c-inc-mail-editor
                        :mail        = "forwardMail"
                        :incident    = "incident"
                        :step        = "0"
                        :unit        = "unit"
                        :units       = "units"
                        @sended      = "onSended"
                    />
                </div>
            </v-card>
        </v-expand-x-transition>

        <div style="height: 120px" class=" pa-3">
            <div class="v-flex">
                <div class = "mail-subject">
                    {{ mail.subject }}
                </div>
                <v-spacer></v-spacer>
                <div class="v-flex">
                    <c-toolbar-button
                        size="22"
                        color="primary"
                        icon="mdi-arrow-right"
                        tooltip="Zum Ereignis wechseln"
                        @click = "onIncident"
                    />
                </div>            </div>
            <div class="v-flex mt-3">
                <div class="mr-4">
                    <p-inc-outbox-avatar
                        :sender = "mail.replyTo[0].email"
                        :dense  = "false"
                    />
                </div>
                <div>
                    <div class = "mail-sender">
                        {{ from }}
                    </div>
                    <div class="mail-receiver">
                        <span><b>An:</b> {{ to }}</span>
                    </div>
                    <div class="mail-receiver">
                        <span><b>Cc:</b> {{ cc }}</span>
                    </div>
                </div>

            </div>

        </div>
        <p-inc-outbox-attachments
            style="margin-left: 80px"
            :attachments = "mail.attachments"
        />
        <div class="pa-3 pr-2" style="margin-top: 7px;">
            <div v-html="body" class="mail-body" style="overflow-y: scroll" :style="'max-height: ' + (height - 70) + 'px'">

            </div>
        </div>

    </div>
</template>

<script>
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import Inc from "@/modules/inc/service/Inc";
import PIncOutboxAttachments from "@/modules/inc/outbox/components/private/PIncOutboxAttachments.vue";
import PIncOutboxAvatar from "@/modules/inc/outbox/components/private/PIncOutboxAvatar.vue";
import CIncMailEditor from "@/modules/inc/mail/CIncMailEditor.vue";
import Mail from "@/modules/inc/mail/service/Mail";

export default {
    name: "PIncOutboxMail",
    components: {
        CIncMailEditor,
        PIncOutboxAvatar,
        PIncOutboxAttachments,
        CToolbarButton
    },

    props: {
        mail: {

        },

        incidentId: {

        },

        height: {

        }
    },

    data: () => ({
        showMailSlide: false,
        incident: null,
        forwardMail: null,
        unit: null,
        units: [],
    }),

    computed: {
        from () {
            if (this.mail.replyTo) {
                let from = "";
                this.mail.replyTo.forEach ((reply, index) => {
                    from = from + reply.name + ' (' + reply.email + ')'
                    if (index < this.mail.replyTo.length-1) {
                        from = from + "; ";
                    }
                });

                return from;
            }

            if (this.mail.from) {
                return this.mail.from.name + " (" + this.mail.from.email +")";
            }

            return null;
        },

        to () {
            if (this.mail.to) {
                let from = "";
                this.mail.to.forEach ((reply, index) => {
                    from = from + reply.email
                    if (index < this.mail.to.length-1) {
                        from = from + "; ";
                    }
                });

                return from;
            }

            return null;
        },

        cc () {
            if (this.mail.cc) {
                let from = "";
                this.mail.cc.forEach ((reply, index) => {
                    from = from + reply.name
                    if (index < this.mail.cc.length-1) {
                        from = from + "; ";
                    }
                });

                return from;
            }

            return null;
        },

        body () {
            const styleStart = this.mail.body.indexOf ("<style");
            const styleEnd   = this.mail.body.indexOf ("</style>");

            if (styleStart >= 0 && styleEnd >= 0) {
                return this.mail.body.substr(0, styleStart-1) + this.mail.body.substr(styleEnd+8);
            }

            return this.mail.body;
        }
    },

    methods: {
        onIncident () {
            Inc.goto(this, this.incidentId);
            this.$emit("close");
        },

        onMail () {
            if (!this.showMailSlide) {
                this.incident = Inc.get(this.incidentId).then(data => {
                    this.incident = data;
                    this.units    = [];
                    this.incident.data[0].collection.forEach (entry => {
                        this.units.push(entry.unit);
                    });

                    this.unit = this.units[0]
                    Mail.mail(null, this.incident, this.index, this.incident.data[0].stepId, { id: -1 }, [  ]).then(mail => {
                        this.forwardMail = mail;
                        this.forwardMail.attachments = this.findDocument(this.mail.id);
                        this.showMailSlide = true;
                    });
                })
            } else {
                this.showMailSlide = false;
            }
        },

        onSended () {
            this.showMailSlide = false;
        },

        findDocument (documentId) {
            const documents = [];
            this.incident.data.forEach(data => {
                data.documents.forEach(doc => {
                    console.log("find doc", doc, documentId)
                    if (doc.id === documentId) {
                        documents.push(doc);
                    }
                })
            });

            return documents;
        }
    }
}
</script>

<style scoped>

.mail-body >>> p {
    margin-bottom: 0!important;
}

.mail-subject {
    font-weight: 600;
    font-size: 15px;
    margin-top: 0px;
    margin-left: 0px;
    max-width: calc(100% - 150px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.mail-sender {
    font-weight: 600;
    font-size: 15px;
    padding-top: 2px;
}

.mail-receiver {
    font-weight: 400;
    font-size: 15px;
}

div::-webkit-scrollbar-thumb {
    min-height: 80px;
}

div::-webkit-scrollbar {
    width: 8px !important;
}

</style>